import React from "react";

import { Box, Grid } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { times } from "lodash";

const EditTimeOffModalSkeleton = () => (
  <Box>
    <Box display="flex" justifyContent="space-between">
      <Skeleton width="120px" height="56px" />
      <Skeleton width="120px" height="56px" />
    </Box>
    <Grid spacing={3} container>
      {times(2, i => (
        <Grid key={i} item xs={6}>
          <Skeleton width="100%" height="60px" />
        </Grid>
      ))}
    </Grid>
    <Grid spacing={3} container>
      {times(2, i => (
        <Grid key={i} item xs={6}>
          <Skeleton width="100%" height="60px" />
        </Grid>
      ))}
    </Grid>
    <Box display="flex" justifyContent="space-between">
      <Skeleton width="120px" height="56px" />
      <Skeleton width="120px" height="56px" />
    </Box>
  </Box>
);

export default EditTimeOffModalSkeleton;
